// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__HZ6Fg","logoContainer":"header_logoContainer__2-4Z1","list":"header_list__3XbVf"};